import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=03c86e56&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=03c86e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.4.1_react-dom@19.2.4_react@18.1.0_vue-templat_7jewe4w6giv7bhauzcsvsdvrzq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c86e56",
  null
  
)

export default component.exports